import initOurRangeNewVehicles from './initOurRangeNewVehicles';

const ourRangeNewVehicles = document.querySelectorAll('.cms-content-our-range-single-brand')
const ourRangeNewVehiclesLength = ourRangeNewVehicles.length;
if (ourRangeNewVehiclesLength > 0) {
    for (let index = 0; index < ourRangeNewVehiclesLength; index++) {
        initOurRangeNewVehicles(ourRangeNewVehicles[index]);
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/cms-content-slices/components/our-range/our-range-new-vehicles.js